"use client"

import { ResponsiveHeader } from "@/components/responsive-header"

export function ContactHeader() {
  return <ResponsiveHeader />
}
